module.exports = __webpack_public_path__ + "static/media/CTLA_1-273w.cfac74bd.jpg";